import {Component, Input} from '@angular/core';
import {ProcessFormsUtil} from "../../utilities/process-forms.util";

@Component({
    selector: 'app-patient-forms-panel',
    templateUrl: './patient-forms-panel.component.html',
    styleUrls: ['./patient-forms-panel.component.scss'],
    standalone: false
})
export class PatientFormsPanelComponent {
    @Input() gridData: any;
    protected readonly ProcessFormsUtil = ProcessFormsUtil;
}
